/**
 * フェイスプレート上のセクション枠。刻印風の見出し + 細罫線で
 * ハードウェアのチャンネルストリップ区画を模す（ページ固有 UI）。
 */

import React, { ReactNode } from "react";
import styled from "styled-components";

import { PANEL, PANEL_FONT } from "../palette";

const Section = styled.section`
  border: 1px solid ${PANEL.sectionBorder};
  border-radius: 8px;
  padding: 18px 14px 14px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`;

const Title = styled.h3`
  position: absolute;
  top: -9px;
  left: 12px;
  margin: 0;
  padding: 0 8px;
  font-family: ${PANEL_FONT};
  font-weight: 800;
  font-size: 12px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: ${PANEL.engravingStrong};
  background:
    linear-gradient(180deg, ${PANEL.faceTop} 0%, ${PANEL.faceTop} 100%);
  line-height: 1.4;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 10px 14px;
`;

export interface PanelSectionProps {
  title: string;
  children: ReactNode;
}

const PanelSection: React.FC<PanelSectionProps> = ({ title, children }) => (
  <Section>
    <Title>{title}</Title>
    <Row>{children}</Row>
  </Section>
);

export default PanelSection;
